import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import {
  ChargeSupplyTransactionsSortKey,
  ChargeSupplyTransactionsOrderTypes,
  ChargeSupplyTransactions,
  ChargerDivision,
} from "@/models/chargeSupplyTransaction";
import { TableSortLabel } from "@/components/atoms/TableSortLabel";
import { TableContainer } from "@mui/material";
import {
  ChargeTransactionConstants,
  getIfChargerTypeQuick,
  formatDate,
} from "./ChargeSupplyTransactionConstants";
import { formatKwh } from "@/util";

export type chargeSupplyTransactionsListProps = {
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  chargeSupplyTransactions: ChargeSupplyTransactions[];
  orderTypes: ChargeSupplyTransactionsOrderTypes;
  onClickChangeSort: (key: ChargeSupplyTransactionsSortKey) => void;
};

export const ChargeSupplyTransactionsList = (
  props: chargeSupplyTransactionsListProps
) => {
  const {
    onChangePage,
    chargeSupplyTransactions,
    pagingData,
    orderTypes,
    onClickChangeSort,
  } = props;

  return (
    <React.Fragment>
      <TableContainer>
        <Table size="small">
          <TableHead className="list-head">
            <TableRow>
              <TableCell>{ChargeTransactionConstants.OfficeName}</TableCell>
              <TableCell>
                {ChargeTransactionConstants.ChargeStartDatetime}
                <TableSortLabel
                  active={
                    chargeSupplyTransactions.length && !!orderTypes.startAt
                      ? true
                      : false
                  }
                  direction={orderTypes.startAt === "desc" ? "desc" : "asc"}
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("startAt")}
                />
              </TableCell>
              <TableCell>
                {ChargeTransactionConstants.ChargeEndDatetime}
                <TableSortLabel
                  active={
                    chargeSupplyTransactions.length && !!orderTypes.endAt
                      ? true
                      : false
                  }
                  direction={orderTypes.endAt === "desc" ? "desc" : "asc"}
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("endAt")}
                />
              </TableCell>
              <TableCell>{ChargeTransactionConstants.ChargeType}</TableCell>
              <TableCell>{ChargeTransactionConstants.ChargerName}</TableCell>
              <TableCell>
                {ChargeTransactionConstants.ChargeCardNumber}
              </TableCell>
              <TableCell>
                {ChargeTransactionConstants.VehicleTypeName}
              </TableCell>
              <TableCell>
                {ChargeTransactionConstants.RadioNumber}
                <TableSortLabel
                  active={
                    chargeSupplyTransactions.length &&
                    !!orderTypes["evCars.cars.vehicleCode"]
                      ? true
                      : false
                  }
                  direction={
                    orderTypes["evCars.cars.vehicleCode"] === "desc"
                      ? "desc"
                      : "asc"
                  }
                  sx={{ ":hover": { color: "red" } }}
                  onClick={() => onClickChangeSort("evCars.cars.vehicleCode")}
                />
              </TableCell>
              <TableCell sx={{ whiteSpace: "pre" }}>
                {ChargeTransactionConstants.ChargeElectricPower}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {chargeSupplyTransactions.map((row) => (
              <TableRow key={row.id} hover sx={{ wordBreak: "break-all" }}>
                <TableCell width="35%">{row.offices.displayName}</TableCell>
                <TableCell>{formatDate(row.startAt)}</TableCell>
                <TableCell>{formatDate(row.endAt)}</TableCell>
                <TableCell>{ChargerDivision[Number(row.type)]}</TableCell>
                <TableCell>{row?.chargers?.name}</TableCell>
                <TableCell>{row.chargeCardManagementNumber ?? "ー"}</TableCell>
                <TableCell>
                  {getIfChargerTypeQuick(row, row.evCars?.evCarModels?.name) ??
                    "ー"}
                </TableCell>
                <TableCell>
                  {getIfChargerTypeQuick(row, row.evCars?.cars?.vehicleCode) ??
                    "ー"}
                </TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  {formatKwh(row.chargeKwh)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size || 3}
        setPage={(page) => onChangePage(page)}
      />
    </React.Fragment>
  );
};
